import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import "./QuickActionsTabs.css";
import { useSearchParams } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { Box, Typography } from "@mui/material";
import PrimaryTabs from "../../../TabPanels/PrimaryTabPanel/PrimaryTabs/PrimaryTabs";
import PrimaryTabPanel from "../../../TabPanels/PrimaryTabPanel/PrimaryTabPanel";
import SecurityCheck from "../../../SecurityCheck/SecurityCheck";
import Callin from "./Callin/Callin";
import Accessorials from "./Accessorials/Accessorials";
import Comchecks from "../QuickActionsTabs/Comchecks/Comchecks";
import RateCon from "./RateCon/RateCon";
import { CarrierService } from "../../../../services/CarrierService";
import { ActiveUserContext, AlertContext } from "../../../Dashboard/Dashboard";

export default function QuickActionsTabs({
  activeLoad,
  handleClose,
  setLoadStatus,
  setLoad,
}) {
  const { instance } = useMsal();
  const { warning } = useContext(AlertContext);
  const activeUser = useContext(ActiveUserContext);
  let [searchParams] = useSearchParams();
  const [tabValue, setTabValue] = useState(0);
  const [carrierExtraPay, setCarrierExtraPay] = useState([]);
  const [comchecksAuthorized, setComchecksAuthorized] = useState(false);
  const [accessorialsAuthorized, setAccessorialsAuthorized] = useState(false);

  const tabLabels = [
    {
      name: "Call In"
    },
    {
      name: "Accessorial"
    },
    {
      name: "Comcheck"
    },
    {
      name: "Rate Confirmation",
      disabled: activeLoad.brokerageStatus === "ONHOLD" || activeLoad.brokerageStatus === "A-RTGDE" || activeLoad.brokerageStatus === "AVA"
    }
  ];

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    searchParams.set("tab", newValue);
    window.history.pushState({}, "", `${window.location.pathname}?${searchParams.toString()}`);
  };
  
  useEffect(() => {
    const tab = searchParams.get("tab");
    setTabValue(tab ? parseInt(tab) : 0);
  }, []);

  useEffect(() => {
    if (activeLoad.id) {
      setTimeout(() => {
        CarrierService.GetCarrierExtraPay(instance, activeLoad.id).then(res => {
          setCarrierExtraPay(res);
        }).catch(error => {
          console.error(error);
          warning(error);
        });
      }, 1);
    }
  }, [activeLoad]);

  return (
    <Box sx={{ height: "100%" }}>
      <Box sx={{ margin: "0 0 10px 0" }}>
        <PrimaryTabs value={tabValue} handleChange={handleTabChange} tabLabels={tabLabels} />
      </Box>
      <PrimaryTabPanel value={tabValue} index={0}>
        <Callin
          setActiveLoad={setLoad}
          setLoadStatus={setLoadStatus}
          activeLoad={activeLoad}
          userId={activeUser?.userIdMcld} />
      </PrimaryTabPanel>
      <SecurityCheck
        componentName="Accessorials"
        action="Create"
        callbackRequired
        callback={setAccessorialsAuthorized}>
        <PrimaryTabPanel value={tabValue} index={1}>
          <Accessorials
            activeUser={activeUser}
            activeLoad={activeLoad}
            handleClose={handleClose}
          />
        </PrimaryTabPanel>
      </SecurityCheck>
      {!accessorialsAuthorized &&
        <PrimaryTabPanel value={tabValue} index={1}>
          <Typography variant="subhead1" color="error.60" sx={{ marginTop: "20px" }}>
            Not authorized to create Accessorials
          </Typography>
        </PrimaryTabPanel>
      }
      <SecurityCheck
        componentName="Comchecks"
        action="Create"
        callbackRequired
        callback={setComchecksAuthorized}>
        <PrimaryTabPanel value={tabValue} index={2}>
          <Comchecks
            activeLoad={activeLoad}
            activeUser={activeUser}
            carrierExtraPay={carrierExtraPay}
          />
        </PrimaryTabPanel>
      </SecurityCheck>
      {!comchecksAuthorized &&
        <PrimaryTabPanel value={tabValue} index={2}>
          <Typography variant="subhead1" color="error.60" sx={{ marginTop: "20px" }}>
            Not authorized to issue Comchecks
          </Typography>
        </PrimaryTabPanel>
      }
      <PrimaryTabPanel value={tabValue} index={3}>
        <RateCon handleClose={handleClose} activeUser={activeUser} activeLoad={activeLoad} />
      </PrimaryTabPanel>
    </Box>
  );
}

QuickActionsTabs.propTypes = {
  activeLoad: PropTypes.object.isRequired,
  handleClose: PropTypes.func.isRequired,
  setLoadStatus: PropTypes.func,
  setLoad: PropTypes.func
};